import Immutable from 'seamless-immutable';
import { GIFT_CARD_RESULT, RESEND_GIFT_CARD_NOTIFICATION } from './actions/giftcard.result.actions';
export var INITIAL_STATE = Immutable({
  data: {},
  giftCardNotificationError: null,
  isFetchingGiftCard: false,
  isResendingGiftCardNotification: false
});
export default function giftCardResultReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var _ref = arguments.length > 1 ? arguments[1] : undefined,
    _ref$payload = _ref.payload,
    payload = _ref$payload === void 0 ? {} : _ref$payload,
    type = _ref.type;
  switch (type) {
    case GIFT_CARD_RESULT.BEGIN:
      return state.set('data', null).set('isFetchingGiftCard', true);
    case GIFT_CARD_RESULT.SUCCESS:
      return state.set('data', payload.Redemption || null).set('isFetchingGiftCard', false);
    case GIFT_CARD_RESULT.FAILURE:
      return state.set('data', null).set('isFetchingGiftCard', false);
    case RESEND_GIFT_CARD_NOTIFICATION.BEGIN:
      return state.set('isResendingGiftCardNotification', true);
    case RESEND_GIFT_CARD_NOTIFICATION.SUCCESS:
      return state.set('isResendingGiftCardNotification', false);
    case RESEND_GIFT_CARD_NOTIFICATION.FAILURE:
      return state.set('isResendingGiftCardNotification', false).set('giftCardNotificationError', [payload.translatedMessage]);
    default:
      return state;
  }
}